
export default {
  name: 'BbSwitсh',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    activeIndex: {
      type: [Number, String],
      default: 0,
    },
    value: [Number, String],
  },
  created() {
    if (this.activeIndex) {
      this.switchItem = this.activeIndex;
    }
  },
  data() {
    return {
      activeSwitchItem: 0,
    };
  },
  computed: {
    switchItem: {
      get() {
        return this.isValueProvided ? this.value : this.activeSwitchItem;
      },
      set(value) {
        if (this.isValueProvided) {
          this.$emit('input', value);
        } else {
          this.activeSwitchItem = value;
        }
      },
    },
    isValueProvided() {
      return typeof this.value !== 'undefined';
    },
  },
  methods: {
    isDisabled(item) {
      return item?.disabled ? item?.disabled : false;
    },
  },
};
